import { html, LitElement, css, unsafeCSS } from "lit";
import { Router } from '@vaadin/router';

import './parts/card';
import './parts/monster';
import './parts/event';

import './pages/index';
import './pages/cards';
import './pages/card';
import './pages/deck';
import './pages/class';
import './pages/monster';
import './pages/seed';
import './pages/area';
import './pages/event';
import './pages/status';
import './pages/changelog';
import './pages/list';
import './pages/seeds';
import './pages/build';
import './pages/stats';
import './pages/speedruns';
import './pages/highscores';
import './pages/user';
import './pages/news';
import './pages/challenge';
import './pages/challenges';
import './pages/builds';
import './pages/ladder';
import './pages/halloffame';
import './pages/carddesigns';

import { NavbarComponent } from './components/navbar';
import './components/menu';

import style from './app.scss';
import { deFriendlyURL, isTouchDevice } from "./shared/utils";
import { DATA_VERSIONS } from "./data/sources";

export class AppComponent extends LitElement {

    static get properties() {
        return {
            route: { type: String, state: true }
        }
    }

    constructor() {
        super();
        this.route = '';    
        this.navbar = new NavbarComponent();
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    firstUpdated() {

        // Setup router.
        const {POPSTATE} = Router.NavigationTrigger;
        Router.setTriggers(POPSTATE);
        const outlet = this.shadowRoot.getElementById('outlet');
        const router = new Router(outlet);
        router.setRoutes([
            {
                path: '/',
                component: 'index-page',
                action: () => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/cards',
                component: 'cards-page',
                action: () => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/talents',
                component: 'cards-page',
                action: () => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/card/:id',
                component: 'card-page',
                action: (ctx) => {
                    this.route = html`<a href="./cards">Cards</a> > ${!isNaN(ctx.params['id']) ? `Card `:''}${deFriendlyURL(ctx.params['id'])}`;
                    this.navbar.results = [];
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/talent/:id',
                component: 'card-page',
                action: (ctx) => {
                    this.route = html`<a href="./talents">Talents</a> > ${!isNaN(ctx.params['id']) ? `Talent `:''}${deFriendlyURL(ctx.params['id'])}`;
                    this.navbar.results = [];
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/cardarchive/:id',
                component: 'card-page',
                action: (ctx) => this.route = html`<a href="./cards">Cards</a> > Card Archive ${ctx.params['id']}`
            },
            {
                path: '/deck/:id',
                component: 'deck-page',
                action: (ctx) => {
                    this.route = html`<a href="./deck/create">Deck</a>${ctx.params['id'].length < 15 ? ` > Deck ${ctx.params['id']}`:''}`;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/class/:name',
                component: 'class-page',
                action: (ctx) => this.route = html``
            },
            {
                path: '/monster/:name',
                component: 'monster-page',
                action: (ctx) => {
                    this.route = html`<a href="./monsters">Monsters</a> > ${deFriendlyURL(ctx.params['name'])}`;
                    this.navbar.results = [];
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/seed/:id',
                component: 'seed-page',
                action: (ctx) => this.route = html`<a href="./seeds">Seeds</a> > ${ctx.params['id']}`
            },
            {
                path: '/area/:name',
                component: 'area-page',
                action: (ctx) => this.route = html``
            },
            {
                path: '/event/:name',
                component: 'event-page',
                action: (ctx) => {
                    this.route = html`<a href="./events">Events</a> > ${deFriendlyURL(ctx.params['name'])}`;
                    this.navbar.results = [];
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/status/:name',
                component: 'status-page',
                action: (ctx) => this.route = html`<a href="./status">Status</a> > ${ctx.params['name']}`
            },
            {
                path: '/changelog/:name',
                component: 'changelog-page',
                action: (ctx) => this.route = html``
            },
            {
                path: '/events',
                component: 'list-page',
                action: (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/monsters',
                component: 'list-page',
                action: (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/status',
                component: 'list-page',
                action: (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/seeds',
                component: 'seeds-page',
                action: (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/build/:name',
                component: 'build-page',
                action: (ctx) => {
                    this.route = html`<a href="./builds">Builds</a> > Build ${ctx.params['name']}`;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/stats',
                component: 'stats-page',
                action: (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/speedruns',
                component: 'speedruns-page',
                action: (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/highscores',
                component: 'highscores-page',
                action: (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/user/:id',
                component: 'user-page',
                action: (ctx) => this.route = html``
            },
            {
                path: '/news/:id',
                component: 'news-page',
                action: (ctx) => this.route = html``
            },
            {
                path: '/discordnews/:id',
                component: 'news-page',
                action: (ctx) => this.route = html``
            },
            {
                path: '/challenge/:id',
                component: 'challenge-page',
                action: (ctx) => this.route = html`<a href="./challenges">Challenges</a> > Challenge ${ctx.params['id']}`
            },
            {
                path: '/challenges',
                component: 'challenges-page',
                action: (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/builds',
                component: 'builds-page',
                action: (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/ladder',
                component: 'ladder-page',
                action: (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/halloffame',
                component: 'halloffame-page',
                action: (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: '/carddesigns/:id',
                component: 'carddesigns-page',
                action: (ctx) => (ctx) => {
                    this.route = html``;
                    this.navbar.toggleMenu(false);
                }
            },
            {
                path: "(.*)",
                action: (context, commands) => {
                    if (context.pathname.startsWith("/auth")) {
                        window.location.href = context.pathname;
                        return;
                    }
                },
            },
        ]);

        // HOT!!
        if (module.hot && window.location.href.indexOf('localhost')!==-1) {
            module.hot.accept((err) => {
                console.log("reloading self");
                window.location.reload();
            })
        }
    }

    render() {
        return html`
            <div class="container" @click=${(ev)=>{if(!isTouchDevice())this.navbar.results=[]}}>
                ${this.navbar}
                <menu-component></menu-component>   
                <div class="crumb">${this.route}</div>                                               
                <div id="outlet"></div>
            </div>
            <div class="footer">
                <div class="footer-part" style="${!isTouchDevice()?'display:inline-block;':''}">
                    <a href="https://dawncaster.wanderlost.games/" target="_blank">Dawncaster</a> v${DATA_VERSIONS[0]}
                </div>    
                <div class="footer-part" style="${!isTouchDevice()?'display:inline-block;':''}">
                    ${!isTouchDevice()?' | ':''}Artwork and game data © <a href="https://wanderlost.games/" target="_blank">Wanderlost Interactive</a>
                </div> 
            </div>
        `;
    }

}

customElements.define('app-component', AppComponent);